var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message)?_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"alert-block",class:{
        'alert-block-warning': _vm.type === 'warning',
        'alert-block-success': _vm.type === 'success',
        'alert-block-error': _vm.type === 'error',
        'alert-block-info': _vm.type === 'info',
        'alert-block-full': _vm.type === 'full'
      }},[_c('p',[_vm._v(_vm._s(_vm.message))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }